import { action, makeAutoObservable, observable } from 'mobx';

class ToasterStore {
  /**@type {Toast[]}*/
  list = [];

  constructor() {
    makeAutoObservable(this, {
      list: observable,
      setList: action.bound,
    });
  }

  removeToast(toastId) {
    this.setList(this.list.filter(({ id }) => id !== toastId));
  }

  addToast(toast) {
    this.setList(this.list.concat(toast));
  }

  setList(list) {
    this.list = list;
  }
}

export const toasterStore = new ToasterStore();